import React from 'react';
import Info from './info';

const FormTextArea = ({
  id,
  name,
  label,
  type,
  placeholder,
  accept,
  defaultValue,
  inputRef,
  rows=3,
  onChange,
  onKeyDown,
  readOnly,
  error,
  errorMessage,
  infos,
  className,
  ...rest
}) => {
  return (
    <div className='pb-[20px] flex flex-col w-full'>
      <div className='flex flex-col'>
        {label && (
          <label className='text-[14px] leading-[23px] font-normal text-color-gray -mb-2'>
            {label}
          </label>
        )}
        <textarea
          name={name}
          type={type}
          placeholder={placeholder}
          accept={accept}
          className={
            readOnly
              ? `bg-color-off-white border text-[13px] rounded-md p-[10px] mt-[10px] text-color-black shadow-sm ${className}`
              : `!bg-white border text-[13px] rounded-md p-[10px]  mt-[10px] text-color-black shadow-sm ${className}`
          }
          rows={rows}
          ref={inputRef}
          onChange={onChange}
          onKeyDown={onKeyDown}
          readOnly={readOnly ? true : false}
          {...rest}
        >
          {defaultValue}
        </textarea>
      </div>
      {error && <span className='text-error'>* {errorMessage}</span>}
      {infos && <Info infos={infos} />}
    </div>
  );
};

export default FormTextArea;
